import * as React from "react";
import { SvgIcon } from "@material-ui/core";

// Google Material Symbols Outlined: star_shine, 24px, weight 400, fill 0.
// Source: https://github.com/google/material-design-icons/blob/master/symbols/web/star_shine/materialsymbolsoutlined/star_shine_24px.svg
// Apache-2.0; see material-symbols-LICENSE.txt.
export const StarShine = (props) => (
  <SvgIcon viewBox="0 -960 960 960" titleAccess="VIP (VIPS)" {...props}>
    <path d="M852-212 732-332l56-56 120 120-56 56ZM708-692l-56-56 120-120 56 56-120 120Zm-456 0L132-812l56-56 120 120-56 56ZM108-212l-56-56 120-120 56 56-120 120Zm246-75 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-361Z" />
  </SvgIcon>
);
